import styled, { css, keyframes } from 'styled-components';

const spin = keyframes`
  to {
    --bg-angle: 1turn;
  }
`;

export const LoaderWrapper = styled.div<{ $isMessagePending: boolean }>`
  ${({ $isMessagePending }) =>
    $isMessagePending &&
    css`
      --bg-angle: 0turn;
      @property --bg-angle {
        inherits: false;
        initial-value: 0deg;
        syntax: '<angle>';
      }

      animation: ${spin} 3s linear infinite;
      background: linear-gradient(
            var(--surface-default),
            var(--surface-default)
          )
          padding-box,
        conic-gradient(from var(--bg-angle), transparent, var(--border-primary))
          border-box;

      border: 2px solid transparent;
      border-radius: 12px;
    `}
`;
